import moment from 'moment';

export default {
  name: 'EcsInteractionTimerMixin',

  methods: {
    createTimer(interaction) {
      let offeredStartTime = interaction.interactionStateTime;

      // NOTE: Patch until ECS can provide the interactionStateTime on refresh
      if (!offeredStartTime) {
        const waitingTime = moment.duration(interaction.timing.waitingTime);
        offeredStartTime = moment.utc(interaction.timing.entryTime).add(waitingTime.as('milliseconds'), 'milliseconds');
      }

      const expirationTimestamp = moment.utc(offeredStartTime).add(interaction.timing.noAnswerTimeout, 'seconds');

      const remaining = Math.max(expirationTimestamp.diff(moment.utc(), 'seconds'), 0);
      return {
        ttl: interaction.timing.noAnswerTimeout,
        remaining,
        expirationTimestamp
      };
    },

    /**
     * Removes an interaction from the interactionTimers map and clears the appropriate timer (interval)
     * @param {EcsInteraction} interactionId
     */
    stopInteractionTimer(timer) {
      if (timer && timer.interval) {
        clearInterval(timer.interval);
      }
    },

    /**
     * Check if pengin interaction are found, and start ringtone and timer for such interactions
     * @param {EcsInteraction[]} pendingInteractions
     */
    checkForPendingInteractions(pendingInteractions) {
      const offeredInteractions = pendingInteractions.some(interaction => interaction.isOffered);

      if (offeredInteractions) {
        this.$ringtoneManager.startInteractionRingtone(pendingInteractions[0]);
        this.startInteractionTimer(pendingInteractions[0]);
        if (pendingInteractions.length === 1) {
          this.open = [0];
        }
        if (pendingInteractions.length >= 3) {
          this.collapseAll();
        }
      } else {
        this.$ringtoneManager.stopInteractionRingtone();
      }
    },

    /**
     * Gets the remaining time until the noAnswerTimeout is reached for a given interaction
     * @param {EcsInteraction} interaction
     * @returns {number}
     */
    getInteractionRemainingTime(interaction, timer) {
      let remaining = 0;
      if (interaction.isPendingConsult) {
        // Consults never expire, even though ECS is incorrectly sending a value for noAnswerTimeout
        remaining = Number.MAX_VALUE;
      } else if (timer) {
        remaining = timer.remaining;
      }
      return remaining;
    }
  }
};
